import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },

  items:{}, //should be object other case will fail
  lastordered:{}, //should be object other case will fail
  goodsExtraData:{}, //pagination info
  topgoods:[], //load firt x goods
  newgoods:[], //load first x new goods
  item:{} //single good item
}

//comuted store.getters.inCart
const getters = {

    getGoodStoreStatus: (state) => {
      return state.status
    },
    getGoodsInCart: (state) => {
      // if(state.items!={}){
      // return state.items.filter(item => item.done)
      // }else{
        return state.items
      // }
    },

    getGoodItems: (state) => {

      return state.items
    },


}

//sync methods store.commit('increment')
const mutations = {
  LOADING_GOOD (state, isLoading){
    state.status.loading = isLoading
  },

  GET_GOOD (state,items){
      state.items = items
  },

  SET_GOOD (state, items){
    state.items = items
  },
  SET_GOOD_EXTRA_DATA (state, data){
    state.goodsExtraData = data
  },
  SET_GOOD_LAST_ORDERED (state, lastordered){
    state.lastordered = lastordered
  },

  SET_TOP_GOODS (state, topgoods){
    state.topgoods = topgoods
  },

  SET_NEW_GOODS (state, newgoods){
    state.newgoods = newgoods
  },

  SET_GOOD_ITEM (state, item){
    state.item = item
  },


}

//async methods  store.dispatch('increment')
const actions = {

  loadSingleGood ({state, commit},id) {
    state.item = {}
    commit('LOADING_GOOD', true);
	
    return api.get('goods/'+id)
      .then(function (response) {
        commit('SET_GOOD_ITEM', response.data.data);
        commit('LOADING_GOOD', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_GOOD', false);
        return Promise.reject(error);
      });

  },

  loadSingleGoodByLink ({state, commit},link) {
    state.item = {}
    commit('LOADING_GOOD', true);

    return api.get('goods-slug/'+link)
      .then(function (response) {
        commit('SET_GOOD_ITEM', response.data.data);
        commit('LOADING_GOOD', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_GOOD', false);
        return Promise.reject(error);
      });

  },

  loadGood ({state, commit},[page,searchTerm,category,categorya,categoryb,filter]) {
    commit('LOADING_GOOD', true);
    category = (category) ? category : '';
    categorya = (categorya) ? categorya : '';
    categoryb = (categoryb) ? categoryb : '';
    filter = (filter) ? filter : '';

    api.get('goods-paginate?page='+page+'&search='+searchTerm+'&category='+category+'&categorya='+categorya+'&categoryb='+categoryb+'&filter='+filter)
      .then(function (response) {
        commit('SET_GOOD_EXTRA_DATA', response.data.goods);
        commit('SET_GOOD', response.data.goods.data);
        commit('LOADING_GOOD', false);
      })
      .catch(function (error) {
        commit('LOADING_GOOD', false);
        console.log(error);
      });
  },

  loadTopGoods ({state, commit},limit) {
    commit('LOADING_GOOD', true);
    api.get('goods-paginate?limit='+limit)
      .then(function (response) {
        commit('SET_TOP_GOODS', response.data.goods.data);
        commit('LOADING_GOOD', false);
      })
      .catch(function (error) {
        commit('LOADING_GOOD', false);
        console.log(error);
      });


  },

  loadNewGoods ({state, commit},limit) {
    commit('LOADING_GOOD', true);
    api.get('goods-paginate?order_by=created_at&limit='+limit)
      .then(function (response) {
        commit('SET_NEW_GOODS', response.data.goods.data);
        commit('LOADING_GOOD', false);
      })
      .catch(function (error) {
        commit('LOADING_GOOD', false);
        console.log(error);
      });
  },

  loadLastOrderedGoods ({state, commit}) {
    commit('LOADING_GOOD', true);
    api.get('goods/lastordered')
      .then(function (response) {
        commit('SET_GOOD_LAST_ORDERED', response.data.goods.data);
        commit('LOADING_GOOD', false);
      })
      .catch(function (error) {
        commit('LOADING_GOOD', false);
        console.log(error);
      });
  },

}

export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/GoodStore.js